import { DsdXlsxConvertPage } from "@/components/team-workspace/dsd-xlsx-convert";
import { LeftSidebar } from "@/components/app-shell";

const MainContent = () => {
  return (
    <div className="flex flex-1 h-full flex-col items-center self-stretch overflow-y-auto relative">
      <DsdXlsxConvertPage />
    </div>
  );
};

const DSDXlsxConvertWorkspace = () => {
  return (
    <div className="inline-flex w-full h-full items-center relative">
      <LeftSidebar activeMenu="dsd-xlsx-convert" />
      <MainContent />
    </div>
  );
};

export default DSDXlsxConvertWorkspace;
